export const POD_IDS_LEGACY = [
  {
    selected: false,
    text: 'Pod 1',
    value: 1,
  },
  {
    selected: false,
    text: 'Pod 2',
    value: 2,
  },
  {
    selected: false,
    text: 'Pod 3',
    value: 3,
  },
  {
    selected: false,
    text: 'Pod 4',
    value: 4,
  },
]

export const POD_IDS_NEW = [
  {
    selected: false,
    text: 'Orange Pod',
    value: 1,
  },
  {
    selected: false,
    text: 'Green Pod',
    value: 2,
  },
  {
    selected: false,
    text: 'Red Pod',
    value: 3,
  },
  {
    selected: false,
    text: 'Yellow Pod',
    value: 4,
  },
  // ID 5 is a deleted POD, so Blue is 6
  {
    selected: false,
    text: 'Blue Pod',
    value: 6,
  },
]
